import { render, staticRenderFns } from "./LineItemErrorTooltip.vue?vue&type=template&id=56d0dd80&"
import script from "./LineItemErrorTooltip.vue?vue&type=script&lang=ts&"
export * from "./LineItemErrorTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./LineItemErrorTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports